
import { Component, Vue, Prop } from "vue-property-decorator";
import DialogCardTitle from "@/components/ui/DialogCardTitle.vue";
import { getModule } from "vuex-module-decorators";
import { Auth, Storage } from "aws-amplify";
import { v4 as uuidv4 } from "uuid";
import VpDialog from "@/components/ui/VpDialog.vue";

import FlashNotifications from "@/store/modules/FlashNotifications";

const flashNotificationsModule = getModule(FlashNotifications);
@Component({
    name: "ImageUploader",
    components: {
        DialogCardTitle,
        VpDialog,
    },
})
export default class ImageUploader extends Vue {
    @Prop({ default: "assets", type: String })
    fileKey!: string;

    private file: File | null = null;
    private userName = "";
    private fileUploaded = false;
    private isLoading = false;
    private fileName = "";

    async mounted(): Promise<void> {
        let authUser = await Auth.currentAuthenticatedUser();
        this.userName = authUser.username;
    }

    get uploadedImage(): File | string {
        return this.file ? URL.createObjectURL(this.file) : "";
    }
    private async getExtension(filename: string): Promise<string> {
        var parts = filename.split(".");
        return "." + parts[parts.length - 1];
    }

    private async uploadMediaFile(): Promise<void> {
        this.isLoading = true;
        let file = this.file ? this.file : "";
        console.log("File:")
        console.log(file);
        this.fileName = uuidv4();
        const key = `images/${this.fileKey}/${this.fileName}`;

        try {
            await Storage.put(key, file, {
                level: "public",
                resumable: true,
                contentType: "image/*",
                completeCallback: () => {
                    flashNotificationsModule.success({
                        message: `Successfully uploaded`,
                        duration: 5000,
                    });
                    this.fileUploaded = true;
                    this.isLoading = false;
                    this.$emit("uploaded", `${this.fileKey}/${this.fileName}`);
                },
            });
            /*
            await Storage.put(key, file, {
                level: "public",
                resumable: true,
                contentType: "image/*",
                completeCallback: () => {
                    flashNotificationsModule.success({
                        message: `Successfully uploaded`,
                        duration: 5000,
                    });
                    this.fileUploaded = true;
                    this.isLoading = false;
                    this.$emit("uploaded", this.fileName);
                },
                errorCallback: (err) => {
                    this.fileUploaded = false;
                    this.isLoading = false;
                    flashNotificationsModule.error({
                        message: `Unexpected error while uploading ${err}`,
                        duration: 10000,
                    });
                },
            });
            */
        } catch (error) {
            console.log(error);
            this.isLoading = false;
            flashNotificationsModule.error({
                message: `Unexpected error while uploading ${error}`,
                duration: 10000,
            });
        }
    }
}
